export enum CallOperationTypeEnum {
        CallAdded = 5162,
        CallUpdated = 5163,
        CallSubmitted = 5164,
}
